<div
  class="page-header"
  [class]="'page-header--' + direction"
  [style]="{ 'justify-content': justify }"
>
  <h1 class="page-header__heading">{{ heading }}</h1>
  <ng-content></ng-content>
</div>
